/**
 * Centralized region and location configuration
 * Maps culture codes to NetSuite location and region IDs
 */
export const REGION_CONFIG = {
  'en-au': { locId: 25, regionId: 7 },
  'en-nz': { locId: 16, regionId: 5 },
  'en-us': { locId: 4, regionId: 4 },
  'es-us': { locId: 4, regionId: 4 }
};

/**
 * Get region configuration for a given culture
 * @param {string} culture - Culture code (e.g., 'en-au', 'en-nz')
 * @returns {Object} Configuration object with locId and regionId
 */
export function getRegionConfig(culture) {
  return REGION_CONFIG[culture] || REGION_CONFIG['en-au'];
}

/**
 * Get location ID for current culture
 * @returns {number} Location ID
 */
export function getLocationId() {
  return getRegionConfig(window.culture).locId;
}

/**
 * Get region ID for current culture
 * @returns {number} Region ID
 */
export function getRegionId() {
  return getRegionConfig(window.culture).regionId;
}

